'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$28() {
  this.bfA = null;
  this.bfy = null;
  this.bfz = false;
  this.bfw = null;
  this.bfx = false;
  this.bfB = false;
  this.bfC = false;
  this.bfA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$28 as $c_Lpresto_PrestoRouter$$anon$28 };
$p = $c_Lpresto_PrestoRouter$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$28;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$28() {
}
export { $h_Lpresto_PrestoRouter$$anon$28 as $h_Lpresto_PrestoRouter$$anon$28 };
$h_Lpresto_PrestoRouter$$anon$28.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bfA;
});
$p.t = (function() {
  if ((!this.bfz)) {
    this.bfy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfz = true;
  }
  return this.bfy;
});
$p.ad = (function() {
  if ((!this.bfx)) {
    this.bfw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfx = true;
  }
  return this.bfw;
});
$p.v = (function() {
  if ((!this.bfC)) {
    this.bfB = false;
    this.bfC = true;
  }
  return this.bfB;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$28, "presto.PrestoRouter$$anon$28", ({
  O2: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$28 as $d_Lpresto_PrestoRouter$$anon$28 };
//# sourceMappingURL=presto.-Presto-Router$$anon$28.js.map
